<template>
  <Countdown :seconds="seconds" @finish="stop" @start="start" />
  <div>Score: {{ score }}</div>
  <div>Multi: x{{ multiplier }}</div>
  <div>Goal: {{ goal }}</div>
  <div class="Birds" ref="Bird">
    <div v-if="finish && !sieger" class="finish">FINISH</div>
    <div v-if="sieger" class="sieger">
      <div>SUCCESS</div>
      <div>your Code is P4</div>
    </div>
    <TransitionGroup name="list" tag="div">
      <div
        v-for="shape in birds"
        :key="shape.id"
        class="bird"
        :class="[shape.shape + '' + shape.dir, shape.shape, shape.speed]"
        :style="{
          top: shape.position.top + 'px',
          left: shape.position.left + 'px',
        }"
      >
        <template v-for="bird in shape.birds" :key="bird.id">
          <div
            class="arrow"
            :color="bird.color"
            :style="{
              transform: 'rotate(' + bird.direction + 'deg)',
            }"
          >
            <img src="@/assets/plane.svg" />
          </div>
        </template>
        <img
          v-if="shape.correct"
          class="correct"
          src="@/assets/check.svg"
          alt="correct"
        />
        <img
          v-if="shape.wrong"
          class="wrong"
          src="@/assets/x.svg"
          alt="wrong"
        />
      </div>
    </TransitionGroup>
  </div>

  <div id="container"></div>
</template>

<script>
function generateRandomInteger(min, max) {
  return Math.floor(min + Math.random() * (max - min + 1));
}

var id = 0;
function getId() {
  id++;
  return id - 1;
}

class Bird {
  constructor(direction, color) {
    this.direction = direction;
    if (color) {
      this.color = color;
    } else this.color = "black";
    this.id = getId();
  }
}

import Countdown from "./Countdown.vue";

export default {
  name: "Planes",
  components: { Countdown },
  data() {
    return {
      score: 0,
      started: false,
      finish: false,
      sieger: false,
      birds: [],
      shapesAvailable: ["line", "cross", "pfeil", "dash", "x"],
      speeds: ["normal", "fast", "rocket"],
      correct: false,
      correctTimer: {},
      multiplier: 1,
      keyPressed: false,
      aimBot: false,
      aimBotspeed: 250,
      seconds: 30,
      goal: 2000,
    };
  },
  methods: {
    removeBird() {
      if (this.finish) return;
      console.log("removing bird");
      if (this.birds[0].wrong || this.birds[0].correct) {
        this.birds.shift();
        return;
      }
      this.birds.shift();
      this.generateRandomShape();
    },
    getNewRemoveTimer(speed) {
      if (this.finish) return;
      var time = 4;
      if (speed == "fast") time = 2;
      if (speed == "rocket") time = 1.5;
      console.log(speed);
      console.log(time);
      var newTimeout = setTimeout(() => {
        this.removeBird();
      }, time * 1000);
      return newTimeout;
    },
    start() {
      this.started = true;
      this.finish = false;
      this.score = 0;
      this.multiplier = 1;
      this.birds = [];
      this.generateRandomShape();
    },
    stop() {
      console.log("FINISH");
      this.finish = true;
    },
    getSpeed() {
      console.log("speed function");
      var speed = "";
      if (Math.floor(Math.random() * 2) % 2 == 1) {
        speed = "normal";
        console.log("speed=normal");
      } else {
        const which = Math.floor(Math.random() * this.speeds.length);
        speed = this.speeds[which];
        console.log("speed=" + speed);
      }
      console.log("speed function ENDE: " + speed);
      return speed;
    },
    getRandomBirdPosition(dir, shape) {
      // 0, 90, 180, 270;
      var elementWidth = 32 * 5;
      // var transitionWidth = 75;
      // var maxTop, maxLeft, minTop, minLeft;
      var ElementOuterWidth = 500;
      // var ElementOuterHeight = ElementOuterWidth;
      var obj = {
        top: 0,
        left: 0,
      };
      if (shape == "x") {
        const xWidth = 90;
        //0 = kommt von links
        if (dir === 0) {
          obj.top = -xWidth;
          obj.left = -xWidth;
        }

        //90 = kommt von oben
        if (dir === 90) {
          obj.left = ElementOuterWidth - xWidth;
          obj.top = -xWidth;
        }

        //von rechts
        if (dir === 180) {
          obj.left = ElementOuterWidth - xWidth;
          obj.top = ElementOuterWidth - xWidth;
        }

        //von unten
        if (dir === 270) {
          obj.top = ElementOuterWidth - xWidth;
          obj.left = -90;
        }
        return obj;
      }
      //0 = kommt von links
      if (dir === 0) {
        obj.top = generateRandomInteger(0, ElementOuterWidth - elementWidth);
        obj.left = -elementWidth;
      }

      //90 = kommt von oben
      if (dir === 90) {
        obj.left = generateRandomInteger(0, ElementOuterWidth - elementWidth);
        obj.top = -elementWidth;
      }

      //von rechts
      if (dir === 180) {
        obj.left = ElementOuterWidth;
        obj.top = generateRandomInteger(0, ElementOuterWidth - elementWidth);
      }

      //von unten
      if (dir === 270) {
        obj.top = ElementOuterWidth;
        obj.left = generateRandomInteger(0, ElementOuterWidth - elementWidth);
      }
      return obj;
    },
    modifyScore(n) {
      this.score += n;
    },
    generateBirds(anzahl, rotationArray) {
      var birds = [];
      for (var i = 0; i < anzahl; i++) {
        if (rotationArray && rotationArray[i] != null) {
          console.log("yes");
          birds.push(new Bird(rotationArray[i]));
        } else {
          birds.push(new Bird());
        }
      }
      return birds;
    },
    other() {
      var newDir = 90 * generateRandomInteger(0, 3);
      // if (newDir === dir) newDir = 90 * generateRandomInteger(0, 3);
      // if (newDir === dir) newDir = 90 * generateRandomInteger(0, 3);
      // if (newDir === dir) newDir = (dir + 180) % 360;

      return newDir;
    },
    generateShape(shape) {
      const anzahl = 5;
      const dir = 90 * generateRandomInteger(0, 3);
      // const dir = 180;

      const speed = this.getSpeed();

      let obj = {
        shape: shape,
        speed: speed,
        dir: dir,
        birds: [],
        position: this.getRandomBirdPosition(dir, shape),
        correct: false,
        id: getId(),
        timer: this.getNewRemoveTimer(speed),
      };

      for (let i = 0; i < anzahl; i++) {
        if (i === 2) {
          obj.birds.push(new Bird(this.other(dir), "red"));
        } else obj.birds.push(new Bird(dir));
      }

      this.birds.push(obj);

      if (this.aimBot) {
        this.autoplay(obj.birds[2].direction);
        // this.autoplay(dir);
      }
    },
    checkKeypressDirection(dir) {
      //get bird, 2 = middle bird and compare direction
      //delete bird or give minus points
      for (const shape of this.birds) {
        if (shape.correct) continue;
        if (shape.birds[2].direction === dir) {
          //correct
          //add score
          this.win();
        } else {
          this.loose();
        }
        break;
      }
    },
    checkGoalReached() {
      if (this.score >= this.goal) {
        this.sieger = true;
        this.finish = true;
        return true;
      }
      return false;
    },
    win() {
      for (const bird of this.birds) {
        if (bird.correct || bird.wrong) continue;
        bird.correct = true;
        break;
      }

      this.generateRandomShape();
      this.multiplier++;
      this.modifyScore(10 * this.multiplier);
      this.checkGoalReached();
    },
    loose() {
      for (const bird of this.birds) {
        if (bird.correct || bird.wrong) continue;
        bird.wrong = true;

        break;
      }

      this.generateRandomShape();
      this.modifyScore(-20 * this.multiplier + 2);
      this.multiplier = 1;
    },
    initKeyboard() {
      window.addEventListener("keydown", (event) => {
        if (this.finish) return;
        event.preventDefault();
        if (this.keyPressed) return;
        this.keyPressed = true;
        // console.log(event.code);
        if (event.code === "ArrowLeft") {
          this.checkKeypressDirection(180);
        }
        if (event.code === "ArrowUp") {
          this.checkKeypressDirection(270);
        }
        if (event.code === "ArrowDown") {
          this.checkKeypressDirection(90);
        }
        if (event.code === "ArrowRight") {
          this.checkKeypressDirection(0);
        }
      });

      window.addEventListener("keyup", () => {
        this.keyPressed = false;
      });
    },
    generateRandomShape() {
      const r = generateRandomInteger(0, this.shapesAvailable.length - 1);
      this.generateShape(this.shapesAvailable[r]);
      // this.generateShape("x");
    },
    autoplay(dir) {
      if (this.finish) return;
      setTimeout(() => {
        this.checkKeypressDirection(dir);
      }, this.aimBotspeed);
    },
  },
  created() {
    this.initKeyboard();
    // this.start();
  },
};
</script>

<style scoped>
* {
  --abstand: 32px;
}

.arrow {
  width: 25px;
  height: 25px;
  display: flex;
  justify-content: space-around;
}
.arrow > img {
  width: 25px;
}

.red {
  filter: brightness(0) saturate(100%) invert(30%) sepia(97%) saturate(4928%)
    hue-rotate(350deg) brightness(100%) contrast(148%);
}

.bird {
  /* border: 1px dashed; */
  position: absolute;
  width: calc(var(--abstand) * 5);
  height: calc(var(--abstand) * 5);
  /* border: 1px dotted; */
  /* background: white; */
}

.bird > div {
  position: absolute;
}

.Birds {
  height: 500px;
  width: 500px;
  margin: 0 auto;
  border: 1px dotted;
  position: relative;
  overflow: hidden;
}

.correct {
  width: 40px;
  height: 40px;
  top: 50%;
  left: 50%;
  z-index: 1;
  position: absolute;
  transform: translate(-50%, -50%);
}

.wrong {
  width: 40px;
  height: 40px;
  top: 50%;
  left: 50%;
  z-index: 1;
  position: absolute;
  transform: translate(-50%, -50%);
}

.finish {
  width: 100%;
  height: 100%;
  background: rgb(255 0 0 / 60%);
  z-index: 1;
  position: absolute;
  display: flex;
  align-items: center;
  justify-content: space-around;
  font-size: 100px;
  color: white;
}

.sieger {
  width: 100%;
  height: 100%;
  background: rgb(253 124 50 / 95%);
  z-index: 1;
  position: absolute;
  display: flex;
  align-items: center;
  justify-content: space-around;
  font-size: 80px;
  color: white;
  flex-direction: column;
}

/*LINE */

.line0 > div:nth-child(1) {
  top: calc(var(--abstand) * 2);
  left: 0px;
}
.line0 > div:nth-child(2) {
  top: calc(var(--abstand) * 2);
  left: calc(var(--abstand));
}
.line0 > div:nth-child(3) {
  top: calc(var(--abstand) * 2);
  left: calc(var(--abstand) * 2);
}
.line0 > div:nth-child(4) {
  top: calc(var(--abstand) * 2);
  left: calc(var(--abstand) * 3);
}
.line0 > div:nth-child(5) {
  top: calc(var(--abstand) * 2);
  left: calc(var(--abstand) * 4);
}

.line90 > div:nth-child(1) {
  top: 0px;
  left: calc(var(--abstand) * 2);
}
.line90 > div:nth-child(2) {
  top: calc(var(--abstand));
  left: calc(var(--abstand) * 2);
}
.line90 > div:nth-child(3) {
  top: calc(var(--abstand) * 2);
  left: calc(var(--abstand) * 2);
}
.line90 > div:nth-child(4) {
  top: calc(var(--abstand) * 3);
  left: calc(var(--abstand) * 2);
}
.line90 > div:nth-child(5) {
  top: calc(var(--abstand) * 4);
  left: calc(var(--abstand) * 2);
}

.line180 > div:nth-child(1) {
  top: calc(var(--abstand) * 2);
  left: 0px;
}
.line180 > div:nth-child(2) {
  top: calc(var(--abstand) * 2);
  left: calc(var(--abstand));
}
.line180 > div:nth-child(3) {
  top: calc(var(--abstand) * 2);
  left: calc(var(--abstand) * 2);
}
.line180 > div:nth-child(4) {
  top: calc(var(--abstand) * 2);
  left: calc(var(--abstand) * 3);
}
.line180 > div:nth-child(5) {
  top: calc(var(--abstand) * 2);
  left: calc(var(--abstand) * 4);
}

.line270 > div:nth-child(1) {
  top: 0px;
  left: calc(var(--abstand) * 2);
}
.line270 > div:nth-child(2) {
  top: calc(var(--abstand));
  left: calc(var(--abstand) * 2);
}
.line270 > div:nth-child(3) {
  top: calc(var(--abstand) * 2);
  left: calc(var(--abstand) * 2);
}
.line270 > div:nth-child(4) {
  top: calc(var(--abstand) * 3);
  left: calc(var(--abstand) * 2);
}
.line270 > div:nth-child(5) {
  top: calc(var(--abstand) * 4);
  left: calc(var(--abstand) * 2);
}

/*CROSS */

.cross > div:nth-child(1) {
  top: calc(var(--abstand));
  left: calc(var(--abstand) * 2);
}
.cross > div:nth-child(2) {
  top: calc(var(--abstand) * 2);
  left: calc(var(--abstand));
}
.cross > div:nth-child(3) {
  top: calc(var(--abstand) * 2);
  left: calc(var(--abstand) * 2);
}
.cross > div:nth-child(4) {
  top: calc(var(--abstand) * 2);
  left: calc(var(--abstand) * 3);
}
.cross > div:nth-child(5) {
  top: calc(var(--abstand) * 3);
  left: calc(var(--abstand) * 2);
}

/*PFEIL */

.pfeil180 > div:nth-child(1) {
  left: calc(var(--abstand) * 2);
  top: 0px;
}
.pfeil180 > div:nth-child(2) {
  top: calc(var(--abstand));
  left: calc(var(--abstand));
}
.pfeil180 > div:nth-child(3) {
  top: calc(var(--abstand) * 2);
  left: 0px;
}
.pfeil180 > div:nth-child(4) {
  top: calc(var(--abstand) * 3);
  left: calc(var(--abstand));
}
.pfeil180 > div:nth-child(5) {
  left: calc(var(--abstand) * 2);
  top: calc(var(--abstand) * 4);
}

.pfeil90 > div:nth-child(1) {
  top: 0px;
  left: 0px;
}
.pfeil90 > div:nth-child(2) {
  top: calc(var(--abstand));
  left: calc(var(--abstand));
}
.pfeil90 > div:nth-child(3) {
  top: calc(var(--abstand) * 2);
  left: calc(var(--abstand) * 2);
}
.pfeil90 > div:nth-child(4) {
  top: calc(var(--abstand));
  left: calc(var(--abstand) * 3);
}
.pfeil90 > div:nth-child(5) {
  left: calc(var(--abstand) * 4);
  top: 0px;
}

.pfeil270 > div:nth-child(1) {
  left: 0px;
  top: calc(var(--abstand) * 2);
}
.pfeil270 > div:nth-child(2) {
  top: calc(var(--abstand));
  left: calc(var(--abstand));
}
.pfeil270 > div:nth-child(3) {
  top: 0px;
  left: calc(var(--abstand) * 2);
}
.pfeil270 > div:nth-child(4) {
  top: calc(var(--abstand));
  left: calc(var(--abstand) * 3);
}
.pfeil270 > div:nth-child(5) {
  left: calc(var(--abstand) * 4);
  top: calc(var(--abstand) * 2);
}

.pfeil0 > div:nth-child(1) {
  left: 0px;
  top: 0px;
}
.pfeil0 > div:nth-child(2) {
  top: calc(var(--abstand));
  left: calc(var(--abstand));
}
.pfeil0 > div:nth-child(3) {
  top: calc(var(--abstand) * 2);
  left: calc(var(--abstand) * 2);
}
.pfeil0 > div:nth-child(4) {
  top: calc(var(--abstand) * 3);
  left: calc(var(--abstand));
}
.pfeil0 > div:nth-child(5) {
  left: 0px;
  top: calc(var(--abstand) * 4);
}

/*DASH*/
.dash0 > div:nth-child(1),
.dash180 > div:nth-child(1) {
  top: 0px;
  left: 0px;
}
.dash0 > div:nth-child(2),
.dash180 > div:nth-child(2) {
  top: calc(var(--abstand));
  left: calc(var(--abstand));
}
.dash0 > div:nth-child(3),
.dash180 > div:nth-child(3) {
  top: calc(var(--abstand) * 2);
  left: calc(var(--abstand) * 2);
}
.dash0 > div:nth-child(4),
.dash180 > div:nth-child(4) {
  top: calc(var(--abstand) * 3);
  left: calc(var(--abstand) * 3);
}
.dash0 > div:nth-child(5),
.dash180 > div:nth-child(5) {
  top: calc(var(--abstand) * 4);
  left: calc(var(--abstand) * 4);
}

.dash90 > div:nth-child(1),
.dash270 > div:nth-child(1) {
  top: 0px;
  left: calc(var(--abstand) * 4);
}
.dash90 > div:nth-child(2),
.dash270 > div:nth-child(2) {
  top: calc(var(--abstand));
  left: calc(var(--abstand) * 3);
}
.dash90 > div:nth-child(3),
.dash270 > div:nth-child(3) {
  top: calc(var(--abstand) * 2);
  left: calc(var(--abstand) * 2);
}
.dash90 > div:nth-child(4),
.dash270 > div:nth-child(4) {
  top: calc(var(--abstand) * 3);
  left: calc(var(--abstand));
}
.dash90 > div:nth-child(5),
.dash270 > div:nth-child(5) {
  top: calc(var(--abstand) * 4);
  left: 0px;
}

/* x */
.x > div:nth-child(1) {
  top: calc(var(--abstand));
  left: calc(var(--abstand));
}
.x > div:nth-child(2) {
  top: calc(var(--abstand));
  left: calc(var(--abstand) * 3);
}
.x > div:nth-child(3) {
  top: calc(var(--abstand) * 2);
  left: calc(var(--abstand) * 2);
}
.x > div:nth-child(4) {
  top: calc(var(--abstand) * 3);
  left: calc(var(--abstand));
}
.x > div:nth-child(5) {
  top: calc(var(--abstand) * 3);
  left: calc(var(--abstand) * 3);
}

/*ANIMATIONS*/
.line0,
.cross0,
.pfeil0,
.dash0 {
  transform: translateX(662px);
}
.line90,
.cross90,
.pfeil90,
.dash90 {
  transform: translateY(662px);
}
.line180,
.cross180,
.pfeil180,
.dash180 {
  transform: translateX(-662px);
}
.line270,
.cross270,
.pfeil270,
.dash270 {
  transform: translateY(-662px);
}

.x0 {
  transform: translate(572px, 572px);
}
.x90 {
  transform: translate(-572px, 572px);
}
.x180 {
  transform: translate(-572px, -572px);
}
.x270 {
  transform: translate(572px, -572px);
}

.move0 {
  transition: all 2s ease;
  left: 50px !important;
}
.move90 {
  transition: all 2s ease;
  top: 50px !important;
}
.move180 {
  transition: all 2s ease;
  left: -50px !important;
}
.move270 {
  transition: all 2s ease;
  top: -50px !important;
}

.list-move,
.list-enter-active {
  /* transition: all 4s linear; */
}

.list-enter-from {
  transform: translateX(0px);
}

.slow {
  transition: all 5s linear;
}

.normal {
  transition: all 4s linear;
}

.fast {
  transition: all 2s linear;
}

.rocket {
  transition: all 1.5s linear;
}
</style>
